import { IconButton, Tooltip } from '@optimus-web/core';

export const TooltippedIconButton = Tooltip(IconButton);
